import React from 'react';
import { motion } from 'framer-motion';
export function EliteDetails() {
  return <section className="py-20 bg-offwhite border-b border-gray-200" data-id="element-65">
      <div className="max-w-4xl mx-auto px-4" data-id="element-66">
        <div className="text-center mb-12" data-id="element-67">
          <h3 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-68">
            ¿Qué agrega el Megapack Elite?
          </h3>
          <p className="text-xl text-gray-600 font-medium" data-id="element-69">
            Por solo $9.000 más, transformás tu enseñanza en un negocio real.
          </p>
        </div>

        <div className="space-y-6" data-id="element-70">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200 flex flex-col md:flex-row gap-6 items-start" data-id="element-71">
            <div className="bg-tennis-green/10 p-4 rounded-xl text-4xl shrink-0" data-id="element-72">
              🛡️
            </div>
            <div data-id="element-73">
              <h4 className="text-2xl font-bold text-charcoal mb-3" data-id="element-74">
                Elite 1 — El Método Anti-Cancelación
              </h4>
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-75">
                El sistema paso a paso para cobrar por cupo mensual y garantizar
                tus ingresos los 12 meses del año. Aunque llueva. Aunque el
                alumno te falle. Aunque haya feriado. Tu sueldo deja de depender
                de las ganas del alumno.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200 flex flex-col md:flex-row gap-6 items-start" data-id="element-76">
            <div className="bg-clay-orange/10 p-4 rounded-xl text-4xl shrink-0" data-id="element-77">
              ⚡
            </div>
            <div data-id="element-78">
              <h4 className="text-2xl font-bold text-charcoal mb-3" data-id="element-79">
                Elite 2 — La Máquina de Grupos
              </h4>
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-80">
                La ingeniería de cancha para manejar 4 alumnos por hora con
                calidad premium. Cuadruplicá tu facturación por hora sin
                trabajar un solo minuto más. El sistema relay que hace que cada
                alumno sienta que tuvo clase particular.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}